export function updateInputLabelDisplay(label, input, textMapping, required = true) {
  if (!label || !input || !textMapping) { return };

  $(label).text(textMapping);
  $(input).attr('placeholder', textMapping);

  if (required) {
    const abbr = '<abbr title="required"> *</abbr>'
    $(label).append(abbr);
  }
}

export function toggleInputVisibilityAndState(input, shouldShow, shouldRequire) {
  if (!input) { return; }

  const wrapper = input.closest('.form-group');
  if (wrapper) {
    wrapper.hidden = !shouldShow;
  }

  input.required = !!shouldRequire;
  input.disabled = !shouldShow;

  if (!shouldShow) {
    clearFieldValueAndValidation(input);
  }
}

export function clearInputValidationError(input) {
  if (!input) { return; }

  input.classList.remove('is-invalid');

  const formGroup = input.closest('.form-group');
  if (!formGroup) { return; }

  const feedback = formGroup.querySelector('.invalid-feedback');
  if (feedback) {
    feedback.remove();
  }
}

export function clearFieldValueAndValidation(input) {
  if (!input) { return; }

  if (input._flatpickr) {
    input._flatpickr.clear();
  } else {
    input.value = '';
  }

  clearInputValidationError(input);
}

